import { useState } from 'react';
import { api } from '../api';
import { useAuth } from '../auth/AuthContext';
import { Alert, Chip, Empty, Loading, PageHeader, useLoad } from '../components/ui';
import { AUDIT_LABEL, fullDateTime, ROLE_LABEL } from '../format';

/** 감사 로그: 센터장은 자기 센터(본사 대리접속 기록 포함), 본사는 센터를 골라서 본다. */
export function Audit() {
  const { me } = useAuth();
  const isHq = me!.role === 'HQ_ADMIN' && !me!.impersonation;
  const [centerId, setCenterId] = useState('');
  const centers = useLoad(() => (isHq ? api.hqCenters() : Promise.resolve(null)), [isHq]);
  const log = useLoad(() => api.audit(isHq ? centerId || undefined : undefined), [isHq, centerId]);

  return (
    <>
      <PageHeader title="감사 로그"
        actions={isHq && centers.data && (
          <div className="inline-field">
            <label htmlFor="audit-center">범위</label>
            <select id="audit-center" value={centerId} onChange={(e) => setCenterId(e.target.value)}>
              <option value="">본사 기록</option>
              {centers.data.centers.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
        )} />
      {log.error && <Alert>{log.error}</Alert>}
      {log.loading && !log.data && <Loading />}
      {log.data?.events.length === 0 && <Empty>아직 기록이 없습니다.</Empty>}
      {log.data && log.data.events.length > 0 && (
        <div className="table-wrap">
          <table className="table">
            <caption className="sr-only">감사 로그</caption>
            <thead><tr><th scope="col">일시</th><th scope="col">실행자</th><th scope="col">작업</th><th scope="col">대상</th><th scope="col">사유</th></tr></thead>
            <tbody>
              {log.data.events.map((e) => (
                <tr key={e.id}>
                  <td className="nowrap small">{fullDateTime(e.at)}</td>
                  <td>{ROLE_LABEL[e.actorRole]}{e.impersonationId && <> <Chip tone="warn">대리접속</Chip></>}</td>
                  <td>{AUDIT_LABEL[e.action] ?? e.action}</td>
                  <td className="small mono">{e.targetType ? `${e.targetType} ${e.targetId ?? ''}` : '-'}</td>
                  <td className="small">{e.reason ?? '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
